import { defineAction } from '~/prix'
import actionJson from './waterSourceDocumentConfirm.action.json' with { type: 'json' }
import { z } from 'zod'
import { waterSourceDocumentStatus } from '../waterSourceDocumentObject'

const definition = defineAction({
  ...actionJson,
  input: z.object({ id: z.string().uuid(), status: waterSourceDocumentStatus }),
  output: z.object({}),
})

export default definition
